import { render, staticRenderFns } from "./Template.vue?vue&type=template&id=192132bc"
var script = {}
import style0 from "./Template.vue?vue&type=style&index=0&id=192132bc&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/Cancer Genetics - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('192132bc')) {
      api.createRecord('192132bc', component.options)
    } else {
      api.reload('192132bc', component.options)
    }
    module.hot.accept("./Template.vue?vue&type=template&id=192132bc", function () {
      api.rerender('192132bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/portals/CancerGenetics/views/Index/Template.vue"
export default component.exports